<mat-dialog-content>
    <div>
    <span class="d-flex justify-content-end">
      <i (click)="onClose()" style="cursor: pointer" class="ms-Icon ms-Icon--Cancel"></i>
    </span>
    </div>
    <p style="text-align: center; font-size: 14px">
        {{ dialogData.message }}
    </p>
    <div class="d-flex justify-content-center mt-3">
        <button class="phish-primary-btn"
                style="padding: 5px 15px; font-size: 14px;"
                (click)="submit()">
          {{ dialogData.confirmBtnText }}
        </button>
        <button class="phish-primary-btn ms-2"
                style="padding: 5px 15px; font-size: 14px;"
                (click)="onDismiss()">
          {{ dialogData.cancelBtnText }}
        </button>
    </div>
</mat-dialog-content>
